import { Button } from '@mantine/core';
import { sizes, variants } from '@uag/react-core';
import { useTranslation } from 'react-i18next';

type DeleteProjectDialogProps = {
    projectName: string;
    isPending: boolean;
    onClose: () => void;
    onDelete: () => void;
};

export const DeleteProjectDialog = ({ projectName, isPending, onClose, onDelete }: DeleteProjectDialogProps) => {
    const { t } = useTranslation();

    return (
        <div className="absolute inset-0 flex items-center justify-center bg-black/25">
            <div
                className="w-[520px] max-w-[92vw] rounded-md border border-border-light bg-background-default shadow-xl"
                onPointerDown={(event) => event.stopPropagation()}
            >
                <div className="border-b border-border-light px-3 py-2 text-sm font-semibold text-text-default">
                    {t('projectsDeleteTitle')}
                </div>

                <div className="space-y-3 p-3 text-sm text-text-default">
                    <div>{t('infoProjectsDeleteConfirm', { projectName })}</div>

                    <div className="flex items-center justify-end gap-2">
                        <Button
                            disabled={isPending}
                            size={sizes.button.small}
                            variant={variants.button.secondary}
                            onClick={onClose}
                        >
                            {t('cancel')}
                        </Button>
                        <Button
                            className="bg-background-danger-light text-text-danger hover:bg-background-danger-light/80"
                            loading={isPending}
                            size={sizes.button.small}
                            onClick={onDelete}
                        >
                            {t('delete')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
